export default __webpack_public_path__ + "static/broadcast3-58b4bd33f705ffdfd9fcc66e8249ab7a.png";